<script setup lang="ts">
import { ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { getPage } from '../api';
import { locale, text } from '../i18n';
import { applyDocumentSeo } from '../seo';

const route = useRoute();
const page = ref<Awaited<ReturnType<typeof getPage>> | null>(null);
const error = ref('');

watch([() => route.params.slug, locale], async ([slug]) => {
  try {
    page.value = await getPage(locale.value, String(slug));
    applyDocumentSeo(page.value.seo.title, page.value.seo.description);
  } catch (reason) {
    error.value = reason instanceof Error ? reason.message : text('页面加载失败', 'Unable to load page');
  }
}, { immediate: true });
</script>

<template>
  <div v-if="page">
    <section class="page-hero page-hero--company">
      <div class="container">
        <span class="eyebrow">{{ text('公司信息', 'Company') }}</span><h1>{{ page.title }}</h1><p>{{ page.summary }}</p>
      </div>
    </section><section class="section">
      <article
        class="container rich-content rich-content--page"
        v-html="page.contentHtml || ''"
      />
    </section>
  </div>
  <div
    v-else
    class="container empty-state empty-state--large"
  >
    {{ error || text('正在加载页面…', 'Loading page…') }}
  </div>
</template>
